"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var Ga4Dispatcher = /** @class */function () {
  function Ga4Dispatcher(converters, destination) {
    var _this = this;
    this.requiresBrowser = true;
    this.type = "ga4";
    this.getUserValues = function (_results, logger) {
      var values = {
        dimensions: {}
      };
      var mappings = _this.destination.mappings;
      if (mappings) {
        mappings.forEach(function (mapping) {
          if (!mapping.action) {
            return;
          }
          var action = new Function(mapping.action);
          var result = action();
          if (result) {
            if (mapping.isIdentifier) {
              values.identifier = result;
            } else if (mapping.dimensionName) {
              values.dimensions[mapping.dimensionName] = result;
            }
          }
        });
      }
      logger.debug("GA4 dispatcher - Converted tracking results into Google Analytics data model.", {
        values: values
      });
      return values;
    };
    this.converters = converters;
    this.destination = destination;
  }
  Ga4Dispatcher.prototype.dispatchActivity = function (results, settings, logger) {
    var _this = this;
    var measurementIds = this.destination.measurementIds;
    if (!measurementIds || measurementIds.length == 0) {
      logger.debug("GA4 dispatcher - No measurement ids are set on the destination so no activities will be dispatched.", {
        destination: this.destination
      });
      return;
    }
    //
    //
    if (!results) {
      logger.debug("GA4 dispatcher - No tracked activity results are available to dispatch.", {
        settings: settings
      });
      return;
    }
    //
    //Google Analytics tracking script must be loaded.
    if (typeof window.gtag !== "function") {
      logger.error("GA4 dispatcher - GA tracking script has not been loaded. The tracking script must be loaded before the GA4 dispatcher can dispatch events to GA. Dispatch aborted.", {
        measurementIds: measurementIds,
        activity: results,
        settings: settings
      });
      return;
    }
    //
    //
    var activities = this.destination.activities;
    if (activities && activities.length == 0) {
      logger.debug("GA4 dispatcher - An empty array of activities was specified so no activities will be dispatched.", {
        settings: settings
      });
      return;
    }
    //
    //
    var events = [];
    results.visitActivities.forEach(function (activity) {
      if (activities && activities.indexOf(activity.type) == -1) {
        logger.debug("GA4 dispatcher - The activity type was not selected as an activity to dispatch.", {
          type: activity.type,
          allowed: activities,
          activity: activity,
          settings: settings
        });
        return;
      }
      for (var i = 0; i < _this.converters.length; i++) {
        var gaEvent = _this.converters[i].convert(activity);
        if (!gaEvent) {
          logger.debug("GA4 dispatcher - The activity was not converted into a format that can be dispatched.", {
            activity: activity,
            settings: settings
          });
          continue;
        }
        logger.debug("GA4 dispatcher - The activity was converted into a format that can be dispatched.", {
          activity: activity,
          gaEvent: gaEvent,
          settings: settings
        });
        events.push(gaEvent);
      }
    });
    //
    //
    var userValues = this.getUserValues(results, logger);
    var identifier = userValues.identifier,
      dimensions = userValues.dimensions;
    if (identifier) {
      measurementIds === null || measurementIds === void 0 ? void 0 : measurementIds.forEach(function (id) {
        logger.debug("GA4 dispatcher - Setting user identifier.", {
          measurementId: id,
          identifier: userValues.identifier
        });
        gtag('config', id, {
          'user_id': userValues.identifier
        });
      });
    }
    //
    //
    var onBeforeDispatchData = settings.onBeforeDispatchData;
    events.forEach(function (e) {
      //
      //Events are written to all of the measurement ids that were registered at initialization.
      if (dimensions && Object.keys(dimensions).length > 0) {
        var _a = _this.destination.eventName,
          eventName = _a === void 0 ? "uniform_event" : _a;
        var eventParams = __assign(__assign({}, dimensions), e);
        var data = {
          eventName: eventName,
          eventParams: eventParams
        };
        if (onBeforeDispatchData) {
          data = onBeforeDispatchData(_this.type, data, logger);
          if (!data) {
            logger.debug("GA4 dispatcher - Cancelling dispatch because no event data is available.", {
              originalData: {
                eventName: eventName,
                eventParams: eventParams
              }
            });
            return;
          }
        }
        logger.debug("GA4 dispatcher - Sending event.", __assign({}, data));
        gtag('event', data.eventName, data.eventParams);
      }
    });
  };
  return Ga4Dispatcher;
}();
export { Ga4Dispatcher };